import React, { useEffect } from 'react'
import { makeStyles, useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@mui/material/useMediaQuery"

import Loader from "../assets/loaderSm.gif"

const useStyles = makeStyles((theme) => ({
	transitionScreen: {
		// display: "none",
		opacity: "0",
		height: "0vh",
		width: "100vw",
		transition: "all 500ms ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
	},
	transitioningScreen: {
		width: "100vw",
		height: "100vh",
		backgroundColor: theme.palette.background.main,
		position: "absolute",
		zIndex: 3,
		display: "flex",
		opacity: "1",
		transition: "opacity 10ms height 1000ms ease",
	},
    loader: {
        position: 'absolute',
        zIndex: 4,
        // transform: 'translate(-50%, -50%)'
    }
}))


const TransitionScreen = ({ isChange }) => {
    const theme = useTheme()
	const classes = useStyles()
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    
    useEffect(() => {
        const handleTransition = (x) => {
            const screen = document.getElementById("transitionScreen")
            if(x){
                // screen.classList.remove(classes.transitionScreen)
                screen.classList.add(classes.transitioningScreen)
            } else {
                screen.classList.remove(classes.transitioningScreen)
                // screen.classList.add(classes.transitionScreen)
            }
        }
        handleTransition(isChange)
    
    }, [isChange])

  return (
    <>
    
    <div className={classes.transitionScreen} id="transitionScreen">{isChange ? <img src={Loader} className={classes.loader} /> : null}</div>
    </>
  )
}

export default TransitionScreen